(() => {
  const SPECIAL_SIZE = /(leash|n\/a|not applicable)/i;
  const LEASH_ONLY = /leash\s*only/i;
  const SET_NAMES = /^(set option|set options|style|leash option)$/i;

  function groupName(group) {
    const label = group.querySelector('legend, label.form__label');
    return label ? label.textContent.trim() : '';
  }

  function selectedValue(group) {
    const checked = group.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value;
    const select = group.querySelector('select');
    return select ? select.value : '';
  }

  function chooseValue(group, value) {
    const radios = Array.from(group.querySelectorAll('input[type="radio"]'));
    const radio = radios.find((input) => input.value === value && !input.disabled);
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    const select = group.querySelector('select');
    if (select) {
      const option = Array.from(select.options).find((item) => item.value === value && !item.disabled);
      if (option && select.value !== value) {
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    return false;
  }

  function availableValues(group) {
    const radios = Array.from(group.querySelectorAll('input[type="radio"]'))
      .filter((input) => !input.disabled)
      .map((input) => input.value);

    if (radios.length) return radios;

    const select = group.querySelector('select');
    return select
      ? Array.from(select.options).filter((option) => !option.disabled).map((option) => option.value)
      : [];
  }

  function apply(container) {
    const groups = Array.from(container.querySelectorAll('fieldset.product-form__input, .product-form__input--dropdown'));
    const setGroup = groups.find((group) => SET_NAMES.test(groupName(group)));
    const sizeGroup = groups.find((group) => /^size$/i.test(groupName(group)));

    if (!setGroup || !sizeGroup) return;

    const setChoice = selectedValue(setGroup);
    const sizeChoice = selectedValue(sizeGroup);
    const leashOnly = LEASH_ONLY.test(setChoice);

    let note = container.querySelector('.ldb-leash-size-note');

    if (leashOnly) {
      if (sizeChoice && !SPECIAL_SIZE.test(sizeChoice)) {
        container.dataset.ldbCollarSize = sizeChoice;
      }

      const special = availableValues(sizeGroup).find((value) => SPECIAL_SIZE.test(value));
      if (special && sizeChoice !== special && chooseValue(sizeGroup, special)) return;

      sizeGroup.hidden = true;
      sizeGroup.setAttribute('aria-hidden', 'true');

      if (!note) {
        note = document.createElement('p');
        note.className = 'ldb-leash-size-note form__label';
        note.textContent = 'No collar size is needed for a leash-only order.';
        setGroup.insertAdjacentElement('afterend', note);
      }
      note.hidden = false;
      return;
    }

    sizeGroup.hidden = false;
    sizeGroup.removeAttribute('aria-hidden');
    if (note) note.hidden = true;

    if (SPECIAL_SIZE.test(sizeChoice)) {
      const values = availableValues(sizeGroup).filter((value) => !SPECIAL_SIZE.test(value));
      const restore = values.includes(container.dataset.ldbCollarSize)
        ? container.dataset.ldbCollarSize
        : values[0];
      if (restore) chooseValue(sizeGroup, restore);
    }
  }

  function applyAll(scope = document) {
    scope.querySelectorAll('variant-radios, variant-selects').forEach(apply);
  }

  document.addEventListener('DOMContentLoaded', () => applyAll());
  document.addEventListener('change', (event) => {
    const container = event.target.closest('variant-radios, variant-selects');
    if (container) window.setTimeout(() => apply(container), 0);
  }, true);
  document.addEventListener('shopify:section:load', (event) => applyAll(event.target));
})();